import React from 'react';

const Headset = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M3.33333 11.6667V9.16667C3.33333 7.39856 4.03571 5.70286 5.28595 4.45262C6.5362 3.20238 8.23189 2.5 10 2.5C11.7681 2.5 13.4638 3.20238 14.714 4.45262C15.9643 5.70286 16.6667 7.39856 16.6667 9.16667V11.6667M3.33333 11.6667C3.33333 11.2246 3.50893 10.8007 3.82149 10.4882C4.13405 10.1756 4.55797 10 5 10H5.83333C6.27536 10 6.69928 10.1756 7.01184 10.4882C7.3244 10.8007 7.5 11.2246 7.5 11.6667V14.1667C7.5 14.6087 7.3244 15.0326 7.01184 15.3452C6.69928 15.6577 6.27536 15.8333 5.83333 15.8333H5C4.55797 15.8333 4.13405 15.6577 3.82149 15.3452C3.50893 15.0326 3.33333 14.6087 3.33333 14.1667V11.6667ZM16.6667 11.6667C16.6667 11.2246 16.4911 10.8007 16.1785 10.4882C15.8659 10.1756 15.442 10 15 10H14.1667C13.7246 10 13.3007 10.1756 12.9882 10.4882C12.6756 10.8007 12.5 11.2246 12.5 11.6667V14.1667C12.5 14.6087 12.6756 15.0326 12.9882 15.3452C13.3007 15.6577 13.7246 15.8333 14.1667 15.8333H15M16.6667 11.6667V14.1667C16.6667 14.6087 16.4911 15.0326 16.1785 15.3452C15.8659 15.6577 15.442 15.8333 15 15.8333M15 15.8333C15 17.2142 12.7617 18.3333 10 18.3333",
      stroke: "white",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);

export { Headset };
//# sourceMappingURL=Headset.js.map
